import { Component, inject, OnInit } from '@angular/core';
import { PatientService } from 'src/app/core/services/patient.service';
import { ModalAddPatientComponent } from '../patients/modal-add-patient/modal-add-patient.component';
import { IPatientResponseDTO } from 'src/app/core/domain/patient';
import { map, Observable, startWith } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PatientItemListComponent } from '../patients/patient-item-list/patient-item-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PatientItemListComponent,
    TranslateModule,
    MatDialogModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  patients$: Observable<IPatientResponseDTO[]>;
  filter = new FormControl('', { nonNullable: true });

  private patients: IPatientResponseDTO[] = [];
  private patientService = inject(PatientService);
  private dialog = inject(MatDialog);

  ngOnInit() {
    this.patientService.patients$.subscribe((patients) => {
      this.patients = Array.isArray(patients) ? patients : [];
      this.filter.updateValueAndValidity();
    });

    this.patients$ = this.filter.valueChanges.pipe(
      startWith(''),
      map((text) => this.search(text)),
    );
  }

  addNewPatient() {
    const isMobile = window.innerWidth < 768; // adjust breakpoint as needed
    const dialogRef = this.dialog.open(ModalAddPatientComponent, {
      width: isMobile ? '100%' : '600px', // mobile vs desktop widths
      maxWidth: isMobile ? '100vw' : '80vw',
      panelClass: isMobile ? 'mobile-dialog' : 'desktop-dialog'
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      console.log('Modal closed with:', result);
    });
  }

  private search(text: string): IPatientResponseDTO[] {
    if (!Array.isArray(this.patients)) {
      return [];
    }
    return this.patients.filter((patient) => {
      const term = text.toLowerCase();
      return (
        patient.name?.toLowerCase().includes(term) ?? false
      );
    });
  }
}
